import { themeGet } from '@styled-system/theme-get';
import { get } from 'styled-system';
import { baseTheme } from '../styles';

/**
 * Used to grab a value from the theme, if the theme is not provided
 * it'll default to the base tractor theme
 * @param {string} key theme key
 */
export var fromTheme = function fromTheme(key, fallback) {
  var _get;

  return themeGet(key, (_get = get(baseTheme, key)) != null ? _get : fallback);
};
export var colorGetter = function colorGetter(theme) {
  return function (color) {
    return get(theme.colors, color);
  };
};